<template>
  <default-layout>
    <div class="companies">
      <v-tabs v-model="tab" show-arrows>
        <!-- PROVIDER TAB -->
        <v-tabs-slider></v-tabs-slider>
        <v-tab
          :to="{
            name: 'CompanyShow',
            params: { companyId: $route.params.companyId }
          }"
        >
          Provider
        </v-tab>

        <!-- USERS TAB -->
        <v-tab
          :to="{
            name: 'CompanyUsers',
            params: { companyId: $route.params.companyId }
          }"
        >
          Users
        </v-tab>

        <!-- LISTINGS TAB -->
        <v-tab
          :to="{
            name: 'CompanyFacilities',
            params: { companyId: $route.params.companyId }
          }"
        >
          Listings
        </v-tab>

        <!-- PRICING TAB -->
        <v-tab
          :to="{
            name: 'CompanyPricing',
            params: { companyId: $route.params.companyId }
          }"
        >
          Pricing
        </v-tab>

        <!-- PAYMENTS TAB -->
        <v-tab
          :to="{
            name: 'CompanyPayments',
            params: { companyId: $route.params.companyId }
          }"
        >
          Payments
        </v-tab>
      </v-tabs>

      <router-view></router-view>

      <v-snackbar v-model="showSnack" top :timeout="0" color="info">
        {{ snackMsg }}
        <v-btn text @click="showSnack = false"> Close </v-btn>
      </v-snackbar>
    </div>
  </default-layout>
</template>

<script>
export default {
  name: "Company",
  title: "Company",
  components: {},

  data() {
    return {
      showSnack: false,
      snackMsg: "",
      tab: null
    };
  }
};
</script>
